import { Button } from '@material-tailwind/react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { UserInfo } from '../user-info'
import {
  FiFileText,
  FiFolder,
  FiGrid,
  FiKey,
  FiLock,
  FiLayers,
  FiPackage,
  FiLogOut,
  FiMapPin,
  FiTruck,
  FiUser,
  FiUsers
} from 'react-icons/fi'
import { FaPersonWalking } from 'react-icons/fa6'
import { DataUploadModal } from './components'
import { useState } from 'react'
import { GiHamburgerMenu } from 'react-icons/gi'
import { HasAccess } from '@permify/react-role'
import { useSelector } from 'react-redux'

const SIDEBARCLASSES = 'invisible md:visible lg:visible xl:visible'

const SidebarLink = ({ icon, text, to }) => {
  return (
    <NavLink key={to} to={to}>
      {({ isActive }) => (
        <div
          className={`side-bar__link ${isActive ? 'active' : ''} py-2 px-3 text-sm gap-2`}
        >
          {icon({ className: 'w-4 h-4' })}
          <span className="truncate">{text}</span>
        </div>
      )}
    </NavLink>
  )
}

export const Layout = ({ children, handleLogout }) => {
  const [dataUploadModalOpen, setDataUploadModalOpen] = useState(false)
  const [sidebarClass, setSidebarClass] = useState(SIDEBARCLASSES)
  const currentUser = useSelector((s) => s.user.current)

  const roleNames =
    (currentUser?.roles || [])
      .map((r) => String(r?.name || '').toLowerCase())

  const fromSlice = Array.isArray(currentUser?.role_names)
    ? currentUser.role_names.map((n) => String(n || '').toLowerCase())
    : []

  const isAccessControl =
    roleNames.includes('control de acceso') || fromSlice.includes('control de acceso')

  return (
    <>
      <DataUploadModal
        open={dataUploadModalOpen}
        handler={() => setDataUploadModalOpen(!dataUploadModalOpen)}
      />
      <Button
        type='button'
        className='bg-color-white bg-white border-solid border-2 text-black p-2 absolute top-4 left-4 z-20 visible md:invisible lg:invisible xl:invisible'
        onClick={sidebarClass === SIDEBARCLASSES ? () => setSidebarClass('visible') : () => setSidebarClass(SIDEBARCLASSES)}
      >
        <GiHamburgerMenu />
      </Button>

      <div className={`side-bar ${sidebarClass}`}>
        <div className='side-bar__container h-screen flex flex-col'>
          <div className='flex flex-col gap-4'>
            <img src='/logo.svg' className='w-52 h-16' />
            <UserInfo />
          </div>

          <p className='side-bar__title mt-10'>Módulos</p>

          <div className='flex flex-col gap-1 flex-1 overflow-y-auto pr-1'>
            {!isAccessControl && (
              <>
                <SidebarLink key='/dashboard' icon={FiGrid} text='Dashboard' to='/dashboard' />

                <HasAccess permissions='company#list'>
                  <SidebarLink key='/companies' icon={FiTruck} text='Contratistas' to='/companies' />
                </HasAccess>

                <HasAccess permissions='contract#list'>
                  <SidebarLink key='/contracts' icon={FiFileText} text='Contratos' to='/contracts' />
                </HasAccess>

                <HasAccess permissions='office#list'>
                  <SidebarLink key='/offices' icon={FiMapPin} text='Dependencias' to='/offices' />
                </HasAccess>

                <HasAccess permissions='employee#list'>
                  <SidebarLink key='/employees' icon={FiUsers} text='Personas' to='/employees' />
                </HasAccess>

                <HasAccess permissions='asset#list'>
                  <SidebarLink key='/assets' icon={FiKey} text='Activos' to='/assets' />
                </HasAccess>

                <HasAccess permissions='asset_v2#list'>
                  <SidebarLink key='/assets_v2' icon={FiPackage} text='Activos 2.0' to='/assets_v2' />
                </HasAccess>

                <HasAccess permissions='attachment#list'>
                  <SidebarLink key='/attachments' icon={FiFolder} text='Documentos' to='/attachments' />
                </HasAccess>
              </>
            )}

            <HasAccess permissions='access#activate'>
              <SidebarLink key='/controldeacceso' icon={FiLock} text='Control de acceso' to='/controldeacceso' />
            </HasAccess>

            <HasAccess permissions='visit#register'>
              <SidebarLink key='/visits' icon={FaPersonWalking} text='Visitas' to='/visits' />
            </HasAccess>

          </div>

          <section>
            <div className='flex flex-col gap-1 mb-5'>
              {!isAccessControl && (
                <>
                  <HasAccess permissions='user#list'>
                    <SidebarLink key='/users' icon={FiUser} text='Usuarios' to='/users' />
                  </HasAccess>

                  <HasAccess permissions='import#create'>
                    <a
                      className='side-bar__link'
                      onClick={() => setDataUploadModalOpen(true)}
                    >
                      <FiLayers className='w-5  h-5' />
                      <span>Importar</span>
                    </a>
                  </HasAccess>
                </>
              )}

              <a className='side-bar__link text-red-500' onClick={handleLogout}>
                <FiLogOut className='w-5 h-5' />
                <span className='text-red-500'>Cerrar sesión</span>
              </a>
            </div>
          </section>
        </div>
      </div>

      <div className='main--background'>
        <div className='main--container no-margin-left'>{children}</div>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  sidebarLinks: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.func.isRequired,
      text: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired
    })
  ),
  handleLogout: PropTypes.func.isRequired
}
